import { createContext } from "react";
import { getRoutes } from "../../../config";

import type { CookieConsentContextProps } from "../cookie-consent.types";

export const CookieConsentContext = createContext<CookieConsentContextProps>({
  cookieConfig: null,
  setCookieConfig: () => {},
  routes: getRoutes(""),
  isModalOpen: false,
  openModal: () => {},
  closeModal: () => {},
  handleSaveConsent: () => {},
  fetchCookieConfig: () => {},
  pageInteraction: () => {},
  openInteraction: () => {},
});
